import { Box, Card, CircularProgress, Typography } from "@mui/material";
import * as React from "react";
import { Link, useParams } from "react-router-dom";
import sendRequest from "../dataProvider/sendRequest";

const RegisterVerify = () => {
  const { token } = useParams();
  const [loading, setLoading] = React.useState(true);
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [message, setMessage] = React.useState(
    "Verifying your account, please wait..."
  );

  React.useEffect(() => {
    let isMounted = true;

    const verifyToken = async () => {
      if (!token) {
        if (isMounted) {
          setLoading(false);
          setIsSuccess(false);
          setMessage(
            "Verification link expired or invalid. Please contact support support@happymangocredit.com."
          );
        }
        return;
      }

      const reqUrl = `verifyBanker/${token}`;
      const response = await sendRequest(
        reqUrl,
        {
          data: { token },
        },
        "create"
      );

      if (!isMounted) {
        return;
      }

      if (response && (response.status == "200" || response.code == "200")) {
        setIsSuccess(true);
        setMessage("Verification successful, you can now log in.");
      } else {
        setIsSuccess(false);
        setMessage(
          "Verification failed. Please contact support support@happymangocredit.com."
        );
      }

      setLoading(false);
    };

    verifyToken();

    return () => {
      isMounted = false;
    };
  }, [token]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f2f7fa",
        px: 2,
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 520, p: 4, textAlign: "center" }}>
        <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
          <img src="/images/happymango_logo.png" alt="logo" />
        </Box>

        {loading ? (
          <>
            <CircularProgress size={28} />
            <Typography sx={{ mt: 2, color: "text.secondary" }}>
              {message}
            </Typography>
          </>
        ) : (
          <>
            <Typography
              variant="h6"
              sx={{
                color: isSuccess ? "success.main" : "error.main",
                fontWeight: 700,
              }}
            >
              {message}
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Link
                to="/login"
                style={{
                  textDecoration: "none",
                  color: "#00CCB1",
                  fontWeight: 600,
                }}
              >
                Go to Login
              </Link>
            </Box>
          </>
        )}
      </Card>
    </Box>
  );
};

export default RegisterVerify;
